// Import shared constants from bs-unified-ui
import {
  ANNOUNCEMENT_TYPE,
  DISMISS_BEHAVIOR,
  ANNOUNCEMENT_STATUS,
  BANNER_COLORS,
  BANNER_ICONS,
} from 'bs-unified-ui';

// Re-export for use in other files
export {
  ANNOUNCEMENT_TYPE,
  DISMISS_BEHAVIOR,
  ANNOUNCEMENT_STATUS,
  BANNER_COLORS,
  BANNER_ICONS,
};

// Local constants specific to communication-hub-ui
export const ANNOUNCEMENT_TYPE_OPTIONS = [
  {
    value: ANNOUNCEMENT_TYPE.GLOBAL_BANNER,
    label: 'Global banner',
  },
  {
    value: ANNOUNCEMENT_TYPE.HOME_PAGE_BANNER,
    label: 'Home page banner',
  },
  {
    value: ANNOUNCEMENT_TYPE.POP_UP,
    label: 'Pop-up',
  },
  {
    value: ANNOUNCEMENT_TYPE.RICH_POP_UP,
    label: 'Rich pop-up',
  },
];

export const DISMISS_BEHAVIOR_DESCRIPTIONS = {
  [DISMISS_BEHAVIOR.TEMPORARY_DISMISS]:
    'User can close the message. It will reappear again if they refresh or revisit the page.',
  [DISMISS_BEHAVIOR.PERMANENT_DISMISS]:
    'Once dismissed, it stays hidden for that user until the publisher republishes or updates it.',
  [DISMISS_BEHAVIOR.NON_DISMISSABLE]: 'User cannot close the message.',
};

export const DISMISS_BEHAVIOR_POPUP_OPTIONS = [
  {
    value: DISMISS_BEHAVIOR.TEMPORARY_DISMISS,
    label: 'Temporary dismiss',
  },
  {
    value: DISMISS_BEHAVIOR.PERMANENT_DISMISS,
    label: 'Permanent dismiss',
  },
];

export const DISMISS_BEHAVIOR_BANNER_OPTIONS = [
  {
    value: DISMISS_BEHAVIOR.TEMPORARY_DISMISS,
    label: 'Temporary dismiss',
  },
  {
    value: DISMISS_BEHAVIOR.PERMANENT_DISMISS,
    label: 'Permanent dismiss',
  },
  {
    value: DISMISS_BEHAVIOR.NON_DISMISSABLE,
    label: 'Non-Dismissable',
  },
];

export const BANNER_COLOR_DEFAULT = {
  [ANNOUNCEMENT_TYPE.GLOBAL_BANNER]: BANNER_COLORS.GLOBAL_BANNER[0],
  [ANNOUNCEMENT_TYPE.HOME_PAGE_BANNER]: BANNER_COLORS.HOME_PAGE_BANNER[0],
};

export const MESSAGE_WORD_LIMITS = {
  [ANNOUNCEMENT_TYPE.GLOBAL_BANNER]: 100,
  [ANNOUNCEMENT_TYPE.HOME_PAGE_BANNER]: 100,
  [ANNOUNCEMENT_TYPE.POP_UP]: 100,
  [ANNOUNCEMENT_TYPE.RICH_POP_UP]: 100,
};

export const POS_TYPE = {
  ALL: 'all',
  COVA: 'cova',
  GRENNLINE: 'greenline',
};

export const POS_TYPE_OPTIONS = [
  {
    value: POS_TYPE.ALL,
    label: 'All POS types',
  },
  {
    value: POS_TYPE.COVA,
    label: 'Cova clients only',
  },
  {
    value: POS_TYPE.GRENNLINE,
    label: 'Greenline clients only',
  },
];

export const PROVINCE_TYPE = {
  ALL: 'all',
  SPECIFIC: 'specific',
};

export const PROVINCE_TYPE_OPTIONS = [
  {
    value: PROVINCE_TYPE.ALL,
    label: 'All provinces',
  },
  {
    value: PROVINCE_TYPE.SPECIFIC,
    label: 'Specific provinces only',
  },
];

export const ANNOUNCEMENT_TAB = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
};

export const ANNOUNCEMENT_TAB_LIST = [
  {
    value: ANNOUNCEMENT_TAB.ACTIVE,
    label: 'Active',
  },
  {
    value: ANNOUNCEMENT_TAB.ARCHIVED,
    label: 'Archived',
  },
];

export const ANNOUNCEMENT_STATUS_COLOR = {
  [ANNOUNCEMENT_STATUS.LIVE]: '#1BC47D',
  [ANNOUNCEMENT_STATUS.SCHEDULED]: '#F3BA50',
  [ANNOUNCEMENT_STATUS.ARCHIVED]: '#999999',
};

export const ANNOUNCEMENT_STATUS_INFO = {
  [ANNOUNCEMENT_STATUS.SCHEDULED]: {
    text: 'Scheduled',
    color: '#D6A647',
    backgroundColor: 'rgba(243, 186, 80, 0.10)',
  },
  [ANNOUNCEMENT_STATUS.ARCHIVED]: {
    text: 'Archived',
    color: 'rgba(51, 54, 61, 0.40)',
    backgroundColor: 'rgba(51, 54, 61, 0.05)',
  },
  [ANNOUNCEMENT_STATUS.LIVE]: {
    text: 'Live',
    color: '#0D8050',
    backgroundColor: 'rgba(27, 196, 125, 0.10)',
  },
};

export const STATUS_OPTIONS = [
  { value: ANNOUNCEMENT_STATUS.LIVE, label: 'Live' },
  { value: ANNOUNCEMENT_STATUS.SCHEDULED, label: 'Schedule' },
];

export const SPECIAL_CHAR = '!"#$%&\'()*+,-./:;<=>?@^_{|}~';
export const RegexValidPassword = new RegExp(
  `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[${SPECIAL_CHAR}])[A-Za-z\\d${SPECIAL_CHAR}]{8,}$`,
);

export const DISPLAY_FORMAT = 'MMM D, YYYY';

export const TIME_HOUR_DISPLAY_FORMAT = 'h:mm A';

export const TIMEZONE = 'America/Vancouver';

export const ANNOUNCEMENT_LIST_LIMIT = 15;

export const MOCK_NAVIGATION_DATA = {
  section1: [
    {
      id: 'breadstack',
      icon: 'breadstack',
    },
    {
      id: 'retail',
      icon: 'ubp_cannabis_store',
    },
    {
      id: 'service',
      icon: 'ubp_service',
    },
    {
      id: 'canfleet',
      icon: 'canfleet',
    },
  ],
  section3: [
    {
      id: 'ubp_notification',
      url: '/s/:storeId/notifications',
      icon: 'ubp_bell',
    },
    {
      id: 'settings',
      url: '/s/:storeId/settings/ecommerce',
      icon: 'ubp_setting',
    },
    {
      id: 'profile_photo',
      url: null,
      icon: null,
      popup_items: [
        {
          id: 'my_account_pop_up',
          url: '/s/:storeId/account/my-account',
          caption: 'My account',
          icon: 'ubp_my_account',
        },
        {
          id: 'switch_workspace',
          url: '/workspace-switcher/6699dd07dbb7ba28126cb176',
          caption: 'Switch workspace',
          icon: 'ubp_switch_ws',
        },
        {
          id: 'log_out',
          url: null,
          caption: 'Log out',
          icon: 'ubp_logout',
        },
      ],
    },
  ],
};
